<div style="padding: 24px;">
    <h5>Logging out...</h5>
    <p>We are securly logging you out of the application. Please wait a moment</p>
</div>